import React from 'react';
import cn from 'classnames';
import { Button } from 'antd';
import { notDraggableClass } from '../../../constants/common';
import SilentModeSwitch from '../../SilentModeSwitch/SilentModeSwitch';
import styles from '../ControlPanel.module.scss';

const Header = ({ onClick }) => {
  return (
    <header className={styles.header}>
      <h3 className={styles.title}>Телефония</h3>
      <div className={styles.headerActions}>
        <SilentModeSwitch
          className={cn(
            styles.collapseBtn,
            notDraggableClass,
            styles.silentMode
          )}
        />
        <Button
          icon="line"
          className={cn(styles.collapseBtn, notDraggableClass)}
          onClick={onClick}
        />
      </div>
    </header>
  );
};

export default Header;
